import React from "react";
import { EditContext, Loading, Record, TabbedForm } from "react-admin";
import { useSelector } from "react-redux";
import { AppState } from "../../../common/types";
import "./RoleForm.css";
import { GeneralInformationTab } from "./GeneralInformationTab";
import { ActionPermissionsTab } from "./ActionPermissionsTab";
import { FieldPermissionsTab } from "./FieldPermissionsTab";
import { FormToolbar } from "../../common/form/FormToolbar";
import { useContext } from "react";

interface RoleFormProps {
  isEdit?: boolean;
  record?: Record;
}

export const RoleForm = ({ isEdit, ...props }: RoleFormProps) => {
  const groupedPermissionDefinitions = useSelector(
    (x: AppState) => x.appData.actionPermissions
  );
  const roles = useSelector((x: AppState) => x.appData.roles)?.filter(
    (x) => x.id !== props.record?.id
  );
  const fieldPermissionDefinitions =
    useSelector((x: AppState) => x.appData.fieldPermissions) ?? {};

  const editContext = useContext(EditContext);
  if (isEdit && editContext?.loading) {
    return <Loading />;
  }

  return (
    <TabbedForm
      className="form-create-edit"
      variant="outlined"
      {...props}
      toolbar={
        <FormToolbar
          showDeleteButton={
            !!isEdit && !props.record?.isAssigned && !props.record?.isDefault
          }
        />
      }
    >
      <GeneralInformationTab />
      <ActionPermissionsTab
        disabled={props.record?.isStatic}
        roles={roles}
        groupedPermissionDefinitions={groupedPermissionDefinitions}
      />
      <FieldPermissionsTab
        disabled={props.record?.isStatic}
        roles={roles}
        groupedPermissionDefinitions={fieldPermissionDefinitions}
        isEdit={isEdit}
      />
    </TabbedForm>
  );
};
